import { lazy } from "react";

const Dashboard = lazy(() => import("../pages/protected/Dashboard"));
const Welcome = lazy(() => import("../pages/protected/Welcome"));
const Page404 = lazy(() => import("../pages/protected/404"));
const Blank = lazy(() => import("../pages/protected/Blank"));
const Charts = lazy(() => import("../pages/protected/Charts"));
const Leads = lazy(() => import("../pages/protected/Leads"));
const Messages = lazy(() => import("../pages/protected/Messages"));
const AdminMessages = lazy(() => import("../pages/protected/AdminMessages"));
const AdminSpecialMessages = lazy(() => import("../pages/protected/AdminSpecialMessages"));
const AdminSpecialMeetings = lazy(() => import("../pages/protected/AdminSpecialMeetings"));
const AdminBulletins = lazy(() => import("../pages/protected/AdminBulletins"));
const Schedules = lazy(() => import("../pages/protected/Schedules"));
const AdminSchedules = lazy(() => import("../pages/protected/AdminSchedules"));
const WeeklyBulletins = lazy(() => import("../pages/protected/WeeklyBulletins"));
const Services = lazy(() => import("../pages/protected/Services"));
const AdminServices = lazy(() => import("../features/adminservices"));
const Integration = lazy(() => import("../pages/protected/Integration"));
const Calendar = lazy(() => import("../pages/protected/Calendar"));
const Team = lazy(() => import("../pages/protected/Team"));
const Transactions = lazy(() => import("../pages/protected/Transactions"));
const Bills = lazy(() => import("../pages/protected/Bills"));
const ProfileSettings = lazy(
  () => import("../pages/protected/ProfileSettings"),
);
const GettingStarted = lazy(() => import("../pages/GettingStarted"));
const DocFeatures = lazy(() => import("../pages/DocFeatures"));
const DocComponents = lazy(() => import("../pages/DocComponents"));

export const userRoutes = [
  {
    path: "/",
    component: Welcome,
  },
  {
    path: "/messages",
    component: Messages,
  },
  {
    path: "/schedules",
    component: Schedules,
  },
  {
    path: "/services",
    component: Services,
  },
  {
    path: "/weekly-bulletins",
    component: WeeklyBulletins,
  }

];

export const adminRoutes = [
  {
    path: "/messages",
    component: AdminMessages,
  },
  {
    path: "/special-messages",
    component: AdminSpecialMessages,
  },
  {
    path: "/special-meetings",
    component: AdminSpecialMeetings,
  },
  {
    path: "/schedules",
    component: AdminSchedules,
  },
  {
    path: "/services-assignment/message",
    component: AdminServices,
    extraProps: { viewType: "assignment" },
  },
  {
    path: "/services-assignment/breaking-bread",
    component: AdminServices,
    extraProps: { viewType: "assignment" },
  },
  {
    path: "/services-assignment/sunday-school",
    component: AdminServices,
    extraProps: { viewType: "assignment" },
  },
  {
    path: "/services-assignment/weekly-duties",
    component: AdminServices,
    extraProps: { viewType: "assignment" },
  },
  {
    path: "/services-assignment/bible-study",
    component: AdminServices,
    extraProps: { viewType: "assignment" },
  },
  {
    path: "/services-metadata/message",
    component: AdminServices,
    extraProps: { viewType: "metadata" },
  },
  {
    path: "/services-metadata/breaking-bread",
    component: AdminServices,
    extraProps: { viewType: "metadata" },
  },
  {
    path: "/services-metadata/sunday-school",
    component: AdminServices,
    extraProps: { viewType: "metadata" },
  },
  {
    path: "/services-metadata/weekly-duties",
    component: AdminServices,
    extraProps: { viewType: "metadata" },
  },
  {
    path: "/services-metadata/bible-study",
    component: AdminServices,
    extraProps: { viewType: "metadata" },
  },
  {
    path: "/bulletins",
    component: AdminBulletins,
  },
  {
    path: "/development/dashboard",
    component: Dashboard,
  },
  {
    path: "/development/welcome",
    component: Welcome,
  },
  {
    path: "/development/leads",
    component: Leads,
  },
  {
    path: "/schedules",
    component: Schedules,
  },
  {
    path: "/development/settings-team",
    component: Team,
  },
  {
    path: "/development/calendar",
    component: Calendar,
  },
  {
    path: "/development/transactions",
    component: Transactions,
  },
  {
    path: "/development/settings-profile",
    component: ProfileSettings,
  },
  {
    path: "/development/settings-billing",
    component: Bills,
  },
  {
    path: "/development/getting-started",
    component: GettingStarted,
  },
  {
    path: "/development/features",
    component: DocFeatures,
  },
  {
    path: "/development/components",
    component: DocComponents,
  },
  {
    path: "/development/integration",
    component: Integration,
  },
  {
    path: "/development/charts",
    component: Charts,
  },
  {
    path: "/development/404",
    component: Page404,
  },
  {
    path: "/development/blank",
    component: Blank,
  },
];
